import { FC, useCallback, useContext, useMemo } from 'react';

import { SearchableSelect } from 'components';
import { useSizeTypes } from 'contexts';

import { RedeliveryContext } from '../redelivery-context';

const RedeliveryDetailSizeType: FC<{ id: number }> = ({ id }) => {
  const { redeliveryDetails, setRedeliveryDetails } = useContext(RedeliveryContext);
  const { sizeTypeOptions: catalogOptions } = useSizeTypes();

  const sizeTypeOptions = useMemo(
    () => ['', ...catalogOptions.map(o => o.code)].map(value => ({ value, label: value })),
    [catalogOptions]
  );

  const redeliveryDetailSizeType = useMemo(() => redeliveryDetails.get(id)?.sizeType ?? '', [id, redeliveryDetails]);
  const setRedeliveryDetailSizeType = useCallback(
    (sizeType: string) =>
      setRedeliveryDetails(prevState => new Map(prevState).set(id, { ...prevState.get(id)!, sizeType })),
    [id, setRedeliveryDetails]
  );

  return (
    <SearchableSelect
      containerClass="text-field"
      data-cy="redelivery-size-type-select"
      inputClass={!redeliveryDetailSizeType ? 'blank' : ''}
      label="SIZE TYPE"
      onValueSelected={setRedeliveryDetailSizeType}
      options={sizeTypeOptions}
      value={redeliveryDetailSizeType}
      required
    />
  );
};

export default RedeliveryDetailSizeType;
